"use client";

import React, { useEffect, useMemo, useState } from "react";
import { ComplianceCard } from "@/components/ComplianceCards";
import { useSession as useNextAuthSession } from "next-auth/react";
import { useTranslations } from "next-intl";
import { useSearchParams } from "next/navigation";
import { Heading } from "@/components/ui/typography";

export default function AboutPage() {
  const [mounted, setMounted] = useState(false);
  const { data: session, status } = useNextAuthSession();
  const tProduct = useTranslations("product");
  const searchParams = useSearchParams();

  const isDev = process.env.NODE_ENV !== "production";
  const h1w = searchParams?.get("h1w");
  const h1WeightClass = useMemo(() => {
    if (!isDev) return undefined;
    switch ((h1w || "").toLowerCase()) {
      case "bold":
        return "font-bold";
      case "semibold":
        return "font-semibold";
      case "medium":
        return "font-medium";
      default:
        return undefined;
    }
  }, [h1w, isDev]);

  useEffect(() => {
    setMounted(true);
  }, []);

  // 如果组件未挂载，显示加载中
  if (!mounted) {
    return (
      <div className="max-w-3xl mx-auto p-8">
        <div className="animate-pulse">
          <div className="h-8 bg-gray-200 dark:bg-gray-700 rounded w-1/3 mb-6"></div>
          <div className="space-y-4">
            <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded"></div>
            <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-5/6"></div>
            <div className="h-32 bg-gray-200 dark:bg-gray-700 rounded"></div>
          </div>
        </div>
      </div>
    );
  }

  // 如果会话正在加载，显示加载状态
  if (status === "loading") {
    return (
      <div className="max-w-3xl mx-auto p-8">
        <div className="animate-pulse">
          <div className="h-8 bg-gray-200 dark:bg-gray-700 rounded w-1/3 mb-6"></div>
          <div className="space-y-4">
            <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded"></div>
            <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-5/6"></div>
            <div className="h-32 bg-gray-200 dark:bg-gray-700 rounded"></div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="max-w-3xl mx-auto p-8">
      <Heading
        variant="h1"
        as="h1"
        className={`text-primary mb-6 font-semibold ${h1WeightClass ?? ""}`}
      >
        {tProduct("title")}
      </Heading>
      <p className="text-foreground">{tProduct("description")}</p>
      <ComplianceCard />
    </div>
  );
}
